<div *ngIf="showPersonalInfo" class=" head d-flex align-items-center mt-4">
    <div class="row d-flex align-items-center">
        <ng-container *ngIf="jobPost!==undefined && jobPost!=={}; else elsePersonalInfo">
            <div class="col-lg-2 ext-center mt-3 d-flex justify-content-end">
                <img class="ps-2" src="/assets/images/careers-apply-job.svg" alt="careers-apply-job">
            </div>
            <div class="col-lg-10 mt-3">
                <div class="med-world-basic-font med-world-basic-font__large "></div>
                <div class="personal-info-value">You are applying for the Job <strong>“{{jobPost?.title}}”</strong> at
                    {{jobPost?.company}}</div>
            </div>
        </ng-container>
        <ng-template #elsePersonalInfo style="margin-top: 6px;" >
            <div class="col-lg-1 ext-center  d-flex justify-content-end ms-2" >
                <img class="ps-2" src="../../assets/images/personalInformationImg.svg" height="40px" width="40px">
            </div>
            <div class="col-lg-10 ">
                <div class="med-world-basic-font med-world-basic-font__large "></div>
                <div class="personal-info-value">Much of the information listed below is used to build your portfolio, a
                    customized
                    professional webpage designed to highlight you and your career.</div>
            </div>
        </ng-template>
    </div>
</div>
<div class="personal-infomation" [ngStyle]="{'padding-bottom': !showEditForm ? '0px' : ''}"  [ngClass]="{'mt-4':!showPersonalInfo    }" [formGroup]=" personalForm">

    <div class=" d-flex justify-content-between  ">
            <h2 class="profile-heading label">{{showPersonalInfo?'Personal':'Organization'}} Information</h2>
        <img class="edit-profile " *ngIf="!showEditForm" (click)="editPersonalInfo()"
            src="../../assets/images/editprofile.svg" id="edit-icon">
    </div>

    <div class="row mt-2" *ngIf="showEditForm">
        <div class="d-flex">
            <div *ngIf="!personalForm.get('logo')?.value" class="position-relative">
                <img class="logo logo2" src="assets/images/icons/user-circle.svg" alt="">
                <div *ngIf="isUploading" class="spinner-overlay">
                    <div class="spinner-border text-white" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
            <div *ngIf="personalForm.get('logo')?.value" class="position-relative logo-container">
                <img class="logo logo2" alt="Profile Picture" [src]="personalForm.get('logo')?.value">
                <div *ngIf="isUploading" class="spinner-overlay">
                    <div class="spinner-border text-white" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div [class.mt-1]="!personalForm.get('logo')?.value" [class.mt-3]="personalForm.get('logo')?.value" *ngIf="showEditForm" class="d-flex gap-2">
        <div class="upload-container">
            <input class="d-none" type="file" id="profile" accept=".png,.jpg,.jpeg,.svg" (change)="uploadLogo($event)" />
            <label class="mwe-button mwe-button--primary med-world-basic-font upload med-world-basic-font__medium ps-3 pe-3" for="profile">
                Upload
            </label>
        </div>
        <button *ngIf="personalForm.get('logo')?.value" class="mwe-button remove med-world-basic-font med-world-basic-font__medium ps-3 pe-3 mx-2"
                [ngClass]="{'mwe-button--danger': true}" (click)="removeLogo()">Remove</button>
    </div>
    

    <div class="row mt-2" *ngIf="showEditForm">
        <div class="col-lg-6">

            <div class="row ">
                <h4 class="profile-h4">General Information</h4>
            </div>
            <div class="row end-customer-name" [class.mb-2]="!showEditForm">
                <div class=" label" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm}">Name<span class="text-danger">*</span></div>
                <div class="col-lg-6 personal-info-value "  id="user-name" *ngIf="!showEditForm">{{personalForm.get('name')?.value}}
                </div>
                <div class="col-lg-7 " *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class=" w-100  input-font">
                        <input matInput required formControlName="name" placeholder="Enter Name">
                        <mat-error class="error-message error-msg"
                            *ngIf="personalForm.get('name')?.hasError('required')"><img class="error-icon"
                                loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Name is
                            Required</mat-error>
                            <mat-error class="error-message error-msg end-customer-name-error"
                            *ngIf="personalForm.get('name')?.hasError('pattern') || personalForm.get('name')?.hasError('maxlength')"><img class="error-icon"
                                loading="lazy" alt="" src="./../../assets/images/alert.svg" /> {{personalForm.get('name')?.hasError('pattern')?' Only Alphabets are Allowed':' Limit Exceeded: Max 50 characters'}}</mat-error>
                               
                            
                    </mat-form-field>
                </div>
            </div>
            <div class="row end-customer-orgName" [class.mb-2]="!showEditForm" *ngIf="this.personalForm?.get('account')?.value?.accountType?.name === 'Organization'">
                <div class="label" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm}">Organization Name<span class="text-danger">*</span></div>
                <div class="col-lg-6 personal-info-value" id="user-name" *ngIf="!showEditForm">{{personalForm.get('organization')?.value}}</div>
                <div class="col-lg-7" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="w-100 input-font">
                        <input matInput required formControlName="organization" (input)="removeSpaceAtStart($event)" placeholder="Enter Organization Name">
                        <mat-error class="error-message error-msg" *ngIf="personalForm.get('organization')?.hasError('required')">
                            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Organization Name is Required
                        </mat-error>

                        <mat-error class="error-message error-msg"
                        *ngIf="personalForm.get('organization')?.hasError('required')"><img class="error-icon"
                            loading="eager" alt="" src="./../../assets/images/alert.svg" />Organization Name is
                        Required</mat-error>
                        <mat-error class="error-message error-msg orgName-error" 
                        *ngIf="personalForm.get('organization')?.hasError('pattern') || personalForm.get('organization')?.hasError('maxlength')">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                        {{ 
                            personalForm.get('organization')?.hasError('pattern') ? 'Only alphanumerics are allowed' : 
                            'Limit Exceeded: Max 150 characters' 
                        }}
                    </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row  " [class.mb-2]="!showEditForm" *ngIf="showPersonalInfo">
                <div class="label" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm}">Date of Birth</div>
                <div class="col-lg-6 personal-info-value " *ngIf="!showEditForm">{{personalForm.get('dob')?.value |
                    date:'dd/MM/yyyy'}}</div>
                <div class="col-lg-7" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="input-font w-100">
                        <input matInput [matDatepicker]="datepicker" formControlName="dob" [max]="maxDate"
                            placeholder="mm/dd/yyyy">
                        <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                        <mat-datepicker #datepicker color="primary"></mat-datepicker>
                        <mat-error class="error-message error-msg"
                            *ngIf="personalForm.get('dob')?.hasError('required')"><img class="error-icon" loading="lazy"
                                alt="" src="./../../assets/images/alert.svg" /> DOB is
                            Required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row  " [class.mb-2]="!showEditForm" *ngIf="!showPersonalInfo">
                <div class=" label" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm}">Established In</div>
                <div class="col-lg-6 personal-info-value " *ngIf="!showEditForm">
                    {{personalForm.get('establishedIn')?.value | date:'dd/MM/yyyy'}}</div>
                <div class="col-lg-7" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="input-font w-100">
                        <input matInput [matDatepicker]="datepicker" formControlName="establishedIn"
                            placeholder="mm/dd/yyyy" [max]="maxDate">
                        <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                        <mat-datepicker #datepicker color="primary"></mat-datepicker>
                        <mat-error class="error-message error-msg"
                            *ngIf="personalForm.get('establishedIn')?.hasError('required')"><img class="error-icon"
                                loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                            Established In is Required</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row end-customer-noEmp" [class.mb-2]="!showEditForm" *ngIf="!showPersonalInfo">
                <div class=" label" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm}">No. of Employees
                </div>
                <div class="col-lg-6 personal-info-value " *ngIf="!showEditForm">
                    {{personalForm.get('noEmployees')?.value}}</div>
                <div class="col-lg-7" *ngIf="showEditForm">

                    <mat-form-field appearance="outline" class="input-font w-100">
                        <input matInput (keypress)="numberOnly($event)" formControlName="noEmployees" placeholder="Enter No. of Employees" >
                
                                <mat-error class="error-message error-msg errorEmp noEmp-error" *ngIf="personalForm.get('noEmployees')?.hasError('maxlength')">
                                    <img class="error-icon" loading="eager" alt="" src="./../../assets/images/alert.svg" /> Limit Exceeded:Max 10 characters
                               </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row  " [class.mb-2]="!showEditForm">
                <div class=" label org-email" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm}">Email Address</div>
                <div class="col-lg-6 personal-info-value " *ngIf="!showEditForm">{{personalForm.get('email')?.value}}
                </div>
                <div class="col-lg-7" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="input-font w-100 ">
                        <input matInput required formControlName="email" readonly >
                    </mat-form-field>
                </div>
            </div>
            <div class="row  " [class.mb-2]="!showEditForm">
                <div class=" label" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm} ">Phone<span class="text-danger">*</span></div>
                <div class="col-lg-6 personal-info-value " *ngIf="!showEditForm">{{personalForm.get('phone')?.value}}
                </div>
                <div class="col-lg-7" *ngIf="showEditForm" >
                    <mat-form-field appearance="outline" class="input-font w-100">
                        <input matInput formControlName="phone" placeholder="Enter Phone Number" >
                        <mat-error class="error-message error-msg"
                        *ngIf="personalForm.get('phone')?.hasError('required')"><img
                            class="error-icon" loading="eager" alt="" src="./../../assets/images/alert.svg" /> Phone
                        Number is Required</mat-error>
                        <mat-error class="error-message error-msg" *ngIf="personalForm.get('phone')?.hasError('pattern')">
                           <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />  Enter valid phone number
                        </mat-error>
                       
                        <mat-error class="error-message error-msg"
                            *ngIf="personalForm.get('phone')?.hasError('minlength') || personalForm.get('phone')?.hasError('maxlength')"><img class="error-icon"
                                loading="lazy" alt="" src="./../../assets/images/alert.svg" />{{personalForm.get('phone')?.hasError('minlength')?' Min length should be 5 digits':' Limit Exceeded: Max: 15 digits'}}
                            </mat-error>      
                    </mat-form-field>
                </div>
            </div>


            <div class="row  " [class.mb-2]="!showEditForm" *ngIf="showPersonalInfo">
                <div class=" label" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm}">Gender</div>
                <div class="col-lg-6 personal-info-value " *ngIf="!showEditForm">{{personalForm.get('gender')?.value}}
                </div>
                <div class="col-lg-7" style="margin-top: -5px;margin-bottom: 10px;" *ngIf="showEditForm">
                    <mat-radio-group style="margin-left: -10px;" class="d-flex" [formControl]="gender">
                        <mat-radio-button value="Male"><div style="margin-left:-7px ; margin-top: 2px;">Male</div></mat-radio-button>&nbsp;
                        <mat-radio-button value="Female"><div style="margin-left:-7px ; margin-top: 2px;">Female</div></mat-radio-button>
                    </mat-radio-group>
                 
                </div>
            </div>
            <div class="row  " [class.mb-2]="!showEditForm" *ngIf="showPersonalInfo">
                <div class="label" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm}"> Position</div>
                <div class="col-lg-6 personal-info-value " *ngIf="!showEditForm">
                    {{personalForm.get('position')?.value?.name}}</div>
                <div class="col-lg-7" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="input-font w-100">
                        <input type="text" matInput placeholder="Select Position" 
                               [matAutocomplete]="auto" 
                               [formControl]="positionControl" 
                               (input)="filterPositions()">
                
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onPositionSelected($event)">
                            <mat-option *ngFor="let position of filteredPositions" [value]="position">
                                {{ position?.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="row  end-customer-work" [class.mb-2]="!showEditForm" *ngIf="showPersonalInfo">
                <div class="label" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm}">Currently Working in
                </div>
                <div class="col-lg-6 personal-info-value " *ngIf="!showEditForm">
                    {{personalForm.get('workingIn')?.value}}</div>
                <div class="col-lg-7" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="input-font  w-100">
                        <input matInput  formControlName="workingIn" >                       
            <mat-error class="error-message error-msg end-customer-work-error"
            *ngIf="personalForm.get('workingIn')?.hasError('pattern') || personalForm.get('workingIn')?.hasError('maxlength')">
            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> 
            {{personalForm.get('workingIn')?.hasError('pattern') ?' Only Alphanumerics are allowed':' Limit Exceeded: Max 100 characters'}}
        </mat-error>

       
       
                
                    </mat-form-field>
                </div>
            </div>
            <div class="row  " [class.mb-2]="!showEditForm">
                <div class="label" [ngClass]="{'col-lg-5':showEditForm,'col-lg-6':!showEditForm}">{{ showPersonalInfo ? 'Portfolio' : ' Website ' }} URL </div>
                <div class="col-lg-6 personal-info-value " *ngIf="!showEditForm"><a class="link"
                        (click)="openLink(personalForm.get('url')?.value)">{{personalForm.get('url')?.value}}</a></div>
                <div class="col-lg-7" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="input-font  w-100">
                        <input matInput formControlName="url" placeholder="Enter valid URL">

                        <mat-error class="error-message error-msg" *ngIf="personalForm.get('url')?.hasError('pattern') || personalForm.get('url')?.hasError('maxlength')">
                            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                            {{personalForm.get('url')?.hasError('pattern') ? 'Please enter a valid URL starts with "http", "https", or "www"' : 'Limit exceeded:Max 150 characters'}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

        </div>
        <div class="col-lg-6 ">
            <div class="row ">
                <h4 class="profile-h4">Address Info</h4>
            </div>
            <div class="row  " [class.mb-2]="!showEditForm">
                <div class="col-lg-4 label">Country </div>
                <div class="col-lg-8 personal-info-value ps-0" *ngIf="!showEditForm">
                    {{personalForm.get('country')?.value}} </div>
                <div class="col-lg-8" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="input-font w-100">
                        <input type="text" placeholder="Select Country" aria-label="Number" matInput [formControl]="country"
                            #autoCompleteCountryInput="matAutocompleteTrigger" [matAutocomplete]="auto" (keypress)="preventNumericInput($event, 'country')">
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getStatesDropdown()">
                            <mat-option *ngFor="let option of countryDropdown" [value]="option?.countryName">
                                {{ option?.countryName }}
                            </mat-option>
                        </mat-autocomplete>

                    </mat-form-field>
                </div>
            </div>
            <div class="row  " [class.mb-2]="!showEditForm">
                <div class="col-lg-4 label">State </div>
                <div class="col-lg-8 personal-info-value ps-0" *ngIf="!showEditForm">
                    {{personalForm.get('state')?.value}} </div>
                <div class="col-lg-8" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="input-font w-100">
                        <input type="text" placeholder="Select State" aria-label="Number" matInput [formControl]="state"
                               [matAutocomplete]="stateAuto" #autoCompleteStateInput="matAutocompleteTrigger" (keypress)="preventNumericInput($event, 'state')"
                               [matAutocompleteDisabled]="!country.value">
                        <mat-autocomplete #stateAuto="matAutocomplete" (optionSelected)="getCityDropdown()">
                            <mat-option *ngFor="let option of stateDropdown" [value]="option?.stateName">
                                {{ option?.stateName }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="row  " [class.mb-2]="!showEditForm">
                <div class="col-lg-4 label">City </div>
                <div class="col-lg-8 personal-info-value ps-0" *ngIf="!showEditForm">{{personalForm.get('city')?.value}}
                </div>
                <div class="col-lg-8" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="input-font w-100">
                        <input type="text" placeholder="Select City" aria-label="Number" matInput [formControl]="city"
                               [matAutocomplete]="cityAuto" #autoCompleteCityInput="matAutocompleteTrigger" (keypress)="preventNumericInput($event, 'city')"
                               [matAutocompleteDisabled]="!state.value">
                        <mat-autocomplete #cityAuto="matAutocomplete">
                            <mat-option *ngFor="let option of cityDropdown" [value]="option?.cityName">
                                {{ option?.cityName }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="row  end-customer-zipcode" [class.mb-2]="!showEditForm">
                <div class="col-lg-4 label">ZIP </div>
                <div class="col-lg-8 personal-info-value ps-0" *ngIf="!showEditForm">
                    {{personalForm.get('zipCode')?.value}} </div>
                <div class="col-lg-8" *ngIf="showEditForm">
                    <mat-form-field appearance="outline" class="input-font w-100">
                        <input matInput formControlName="zipCode"  (input)="validateZipCode($event)" (keydown.space)="$event.preventDefault()" placeholder="Enter Valid ZIP Code" onlyNumbers>
                        <mat-error *ngIf="personalForm.get('zipCode')?.value.length < 6 || personalForm.get('zipCode')?.value.length > 8" class="error-message error-msg  end-customer-zipcode-error">
                            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                            <ng-container *ngIf="personalForm.get('zipCode')?.value.length < 6">
                              Invalid ZIP: Must be at least 6 characters.
                            </ng-container>
                            <ng-container *ngIf="personalForm.get('zipCode')?.value.length > 8">
                              Invalid ZIP: Cannot exceed 8 characters.
                            </ng-container>
                          </mat-error>                          
                    </mat-form-field>
                </div>
            </div>
              
            <div class="row" [class.mb-2]="!showEditForm">
                <div class="col-lg-4 label">Address</div>
                <div class="col-lg-8 personal-info-value ps-0" *ngIf="!showEditForm">
                  {{ personalForm.get('address')?.value }}
                </div>
                <div class="col-lg-8" *ngIf="showEditForm">
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input matInput formControlName="address" placeholder="Enter Address" 
                           (input)="removeSpaceAtStart($event)" />
                    <mat-error *ngIf="personalForm.get('address')?.hasError('pattern') || personalForm.get('address')?.hasError('maxlength')" class="error-message error-msg">
                      <img class="error-icon" alt="" src="./../../assets/images/alert.svg" />
                     {{personalForm.get('address')?.hasError('pattern')?' Only Alphanumerics are allowed':' Limit Exceeded: Max 100 characters'}}
                    </mat-error>
                    <mat-error *ngIf="personalForm.get('address')?.hasError('required')">
                      <img class="error-icon" alt="" src="./../../assets/images/alert.svg" class="error-message error-msg"/>
                      Address is required
                    </mat-error>
                    
                  </mat-form-field>
                </div>
              </div>
        </div>
    </div>

    <div class="row info-start" *ngIf="!showEditForm">
        <div class="col-lg-2 d-flex justify-content-center" *ngIf="personalForm.get('logo')?.value" >
            <img alt="" class="logo" src="{{personalForm.get('logo')?.value}}" >
        </div>
        <div class="col-lg-2 d-flex justify-content-center" *ngIf="!personalForm.get('logo')?.value" >
            <img alt="" class="logo" src="assets/images/icons/user-circle.svg" >
        </div>
        <div class="col-lg-4 d-flex flex-column justify-content-center p-first">
            <h1 class="star-hosp mb-0" *ngIf="this.personalForm?.get('account')?.value?.accountType?.name === 'Individual'" id="user-name">{{personalForm.get('name')?.value}}</h1>
            <h1 class="star-hosp mb-1" *ngIf="this.personalForm?.get('account')?.value?.accountType?.name === 'Organization'" id="user-name">{{personalForm.get('organization')?.value}}</h1>
            <div class="d-flex m-0" *ngIf="!showPersonalInfo">
                <label class="etsablish">Established: &nbsp;</label>
                <p class="reg-date"> {{personalForm.get('establishedIn')?.value | date:'dd/MM/yyyy'}}</p>
            </div>
            <div class="d-flex m-0" *ngIf="showPersonalInfo">
                <label class="etsablish">Date of Birth: &nbsp;</label>
                <p class="reg-date"> {{personalForm.get('dob')?.value | date:'dd/MM/yyyy'}}</p>
            </div>

                <div class="d-flex m-0 expandable-container">
                    <label class="address">Address:&nbsp;</label>
                    <p class="expandable-content"
                    style="word-break: break-word;" 
                    [ngClass]="{'expanded': isExpanded.address}" 
                    (click)="toggleExpand('address')">
                        {{personalForm.get('address')?.value}} - {{personalForm.get('zipCode')?.value}}
                    </p>
                </div>
        </div>
        <div class="col-lg-1  vertical-line">

        </div>
        <div class="col-lg-5">
            <div class="d-flex">

                <p class="org-label">Email: &nbsp;</p><p class="expandable-content" 
                [ngClass]="{'expanded': isExpanded.email}" 
                (click)="toggleExpand('email')">{{personalForm.get('email')?.value}}</p>
            </div>
            <div class="d-flex " style="margin-top: -6px;">

                <p class="org-label">Phone: &nbsp;</p>{{personalForm.get('phone')?.value}}

            </div>
            <div class=" d-flex" style="margin-top: -6px;" *ngIf="!showPersonalInfo">
                <p class="org-label">Employees: &nbsp;</p>{{personalForm.get('noEmployees')?.value}}

            </div>
            <div class=" d-flex" style="margin-top: -6px;" *ngIf="!showPersonalInfo">
                <p class="org-label">Website Url: &nbsp;</p>     <p class="expandable-content" 
                [ngClass]="{'expanded': isExpanded.portfolio}" 
                (click)="toggleExpand('portfolio')"><a href="{{personalForm.get('url')?.value}}"><span
                        style="color: #0d87c8">{{personalForm.get('url')?.value}}</span> </a></p>

            </div>
            <div class="" style="margin-top: -6px;" *ngIf="showPersonalInfo">
                <div class="d-flex ">
                    <p class="org-label">Currently Working: &nbsp;</p> <p class="expandable-content" 
                    [ngClass]="{'expanded': isExpanded.working}" 
                    (click)="toggleExpand('working')" >{{personalForm.get('workingIn')?.value}}</p>
                </div>
            </div>
            <div class="" style="margin-top: -6px;" *ngIf="showPersonalInfo">
                <div class="d-flex">
                    <p class="org-label">Position: &nbsp;</p> <p class="expandable-content" 
                    [ngClass]="{'expanded': isExpanded.position}" 
                    (click)="toggleExpand('position')">{{personalForm.get('position')?.value?.name}}</p>
                </div>
            </div>

            <div class=" d-flex" style="margin-top: -6px;" *ngIf="showPersonalInfo">

                <p class="org-label">Portfolio URL: &nbsp;</p>
                <p class="expandable-content" 
       [ngClass]="{'expanded': isExpanded.portfolio}" 
       (click)="toggleExpand('portfolio')"><a class="link" style="text-decoration: none;"
                    (click)="openLink(personalForm.get('url')?.value)">{{personalForm.get('url')?.value}}</a></p>
            </div>


        </div>
    </div>

    <div class="action " *ngIf="showEditForm">


        <button class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3"
            (click)="update()">Update</button>
        <button class="mwe-button mwe-button--secondary ps-3 pe-3 " (click)="cancel()">Cancel</button>
    </div>
</div>